import { supabase } from "./supabase";

/**
 * Authenticated fetch wrapper for API calls.
 * Automatically attaches the Supabase JWT as a Bearer token.
 */
export async function apiFetch(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  const headers = new Headers(options.headers);

  if (session?.access_token) {
    headers.set("Authorization", `Bearer ${session.access_token}`);
  }

  if (options.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  return fetch(url, {
    ...options,
    headers,
  });
}

/**
 * Shorthand for GET requests.
 */
export async function apiGet(url: string): Promise<Response> {
  return apiFetch(url);
}

/**
 * Shorthand for POST requests with JSON body.
 */
export async function apiPost(
  url: string,
  body: unknown
): Promise<Response> {
  return apiFetch(url, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

/**
 * Shorthand for PATCH requests with JSON body.
 */
export async function apiPatch(
  url: string,
  body: unknown
): Promise<Response> {
  return apiFetch(url, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}
